import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { ScientificReframe } from './components/ScientificReframe';
import { ProductPresentation } from './components/ProductPresentation';
import { OfferStack } from './components/OfferStack';
import { HowItWorks } from './components/HowItWorks';
import { ForWho } from './components/ForWho';
import { SocialProof } from './components/SocialProof';
import { FAQ } from './components/FAQ';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen w-full bg-navy font-inter" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      {/* Main content with padding for sticky bar */}
      <main className="pt-10" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPoints data-id="element-4" />
        <ScientificReframe data-id="element-5" />
        <ProductPresentation data-id="element-6" />
        <OfferStack data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <ForWho data-id="element-9" />
        <SocialProof data-id="element-10" />
        <FAQ data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FinalCTA data-id="element-13" />
        <Footer data-id="element-14" />
      </main>
    </div>;
}